function CollectionPageFactory(container) {
  class CollectionPage {
    constructor(container) {
      this.collectionPage = container;
      this._setInfiniteScrollEvents();
      // this._setWishlistButtons();
    }

    _setInfiniteScrollEvents() {
      const productList = this.collectionPage.querySelector(".product-list");

      if (!productList) return;

      const observer = new MutationObserver((mutationsList) => {
        let newProductCardAdded = false;

        for (const mutation of mutationsList) {
          if (mutation.type === "childList" && mutation.addedNodes.length) {
            mutation.addedNodes.forEach((node) => {
              if (
                node.nodeType === 1 &&
                node.classList.contains("product-card")
              ) {
                newProductCardAdded = true;
              }

              // Check inside the added node for product cards as well
              if (
                node.nodeType === 1 &&
                node.querySelector &&
                node.querySelector(".product-card")
              ) {
                newProductCardAdded = true;
              }
            });
          }
        }

        if (newProductCardAdded) {
          setTimeout(() => {
            const event = new CustomEvent("swym:collections-loaded", {
              bubbles: true,
            });
            this.collectionPage.dispatchEvent(event);
          }, 250);
        }
      });

      observer.observe(productList, {
        childList: true,
        subtree: true, // Ensures that we catch nested product cards
      });
    }
  }

  return new CollectionPage(container);
}
